var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitzerland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 39.9999C31.0461 39.9999 40.0004 31.0456 40.0004 19.9999C40.0004 8.95418 31.0461 -0.00012207 20.0004 -0.00012207C8.95471 -0.00012207 0.000411987 8.95418 0.000411987 19.9999C0.000411987 31.0456 8.95471 39.9999 20.0004 39.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4349 16.5218H23.4785V9.56525H16.5219V16.5218H9.56541V23.4783H16.5219V30.4348H23.4785V23.4783H30.4349V16.5218Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitzerland);
export default __webpack_public_path__ + "static/media/switzerland.3cea32aa9b7c138429075f2a8bc6cc05.svg";
export { ForwardRef as ReactComponent };